import React from 'react';
import ChildrenRow from './children/row.js'
import UserHelper from '../../../helper/user.js'

export default{
  RenderRecord(Reducer,self){
    if(Reducer.rs === null){
      return
    }
    var rs = []
    for (var i = 0 ; i < Reducer.rs.length;i++){
        rs.push(
          <ChildrenRow key={i} data={Reducer.rs[i]} self={self} UserReducer={self.props.UserReducer}/>
        )
    }
    return rs
  },
  RenderTableSort(self,label,callback){
    if(self.state.Tracking.TableSort.col === label){
      if(self.state.Tracking.TableSort.asc){
        return(
          <a href="" role="button" tabIndex="1" onClick={()=>callback(self,label)} className="MarginRight"><i className="fa fa-sort-alpha-asc float-right"></i></a>
        )
      }
      return(
        <a href="" role="button" tabIndex="1" onClick={()=>callback(self,label)} className="MarginRight"><i className="fa fa-sort-alpha-desc float-right"></i></a>
      )

    }else{
      return(
        <a href="" role="button" tabIndex="1" onClick={()=>callback(self,label)} className="unactive-sort MarginRight"><i className="fa fa-sort-alpha-asc float-right"></i></a>
      )
    }
  },
  RenderPagination(Reducer,next_action,previous_action,next_props,previous_props){
    var jsx = [];

    if(Reducer.previous !== null){
      jsx.push(
        <li className="page-item" key={'previous'}><a className="page-link" role="button" tabIndex="1" onClick={()=>previous_action(previous_props)}>Previous</a></li>
      )
    }
    if(Reducer.next !== null){
      jsx.push(
        <li className="page-item" key={'next'}><a className="page-link" onClick={()=>next_action(next_props)} role="button" tabIndex="1">Next</a></li>
      )
    }
    return jsx;
  },
  RenderTimelinePagination(self,Reducer,next_action,previous_action,next_props,previous_props){
    var jsx = [];

    if(Reducer.previous !== null){
      jsx.push(
        <li className="page-item" key={'previous'}><a className="page-link" role="button" tabIndex="1" onClick={()=>previous_action(self,previous_props)}>Previous</a></li>
      )
    }
    if(Reducer.next !== null){
      jsx.push(
        <li className="page-item" key={'next'}><a className="page-link" role="button" tabIndex="1" onClick={()=>next_action(self,next_props)}>Next</a></li>
      )
    }
    return jsx;
  },
  RenderRegisterButton(self,permission,UserReducer){
    if(!UserHelper.HasPermission(permission,UserReducer)){
      return false; 
    }
    /* return(
      <div className="new-tracking">
        <button type="button" className="btn btn-sm btn-primary" onClick={self.__ToogleRegisterTrackingModal__}><i className="fa fa-dot-circle-o"></i> Add New Tracking</button>
      </div>
    ) */
  },

  RenderLoadMore(self, Reducer, next_action, next_props) {
    if(self.state.isLoading) {
      return(
        <div>
          <button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button>
        </div>
      )
    } 
    else {
      if(Reducer.next != null) {
        return (
          <div>
            <button className="btn btn-primary" onClick={()=>next_action(self, next_props)}>Load More</button>
          </div>
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/tracking/helper/render.js